// 咨询师列表表头
export let tableLabels = [
  {
    label: '工号',
    value: 'workNumber'
  },
  {
    label: '姓名',
    value: 'fullName'
  },
  {
    label: '职位',
    value: 'positionName'
  },
  {
    label: '执业医院数量（个）',
    value: 'hospitalNum'
  },
  {
    label: '办公电话',
    value: 'officePhone'
  },
  {
    label: '手机',
    value: 'mobile'
  },
  {
    label: '微信',
    value: 'wechatId'
  },
  {
    label: '公司',
    value: 'companyName'
  }
]

// 新闻页面顶部筛选tab
export let counselorTabLabels = [
  {
    label: '职位',
    type: 'select',
    value: 'position',
    clearable: true,
    options: []
  },
  {
    label: '公司名称',
    type: 'select',
    value: 'company',
    clearable: true,
    options: []
  }
]
